import { createStyles } from '@mantine/core';

const useStyles = createStyles(theme => ({
  header: {
    width: '100%',
    background: theme.colors.gray[0],
    padding: theme.spacing.xl,
    paddingBottom: theme.spacing.xl,
    display: 'grid',
    borderBottom: `1px solid ${theme.colors.gray[3]}`,
    borderRadius: 0,
    alignItems: 'center',
    gap: theme.spacing.sm,
    whiteSpace: 'nowrap',
    gridTemplateColumns: '3fr 1fr min-content min-content',
    gridTemplateAreas: `
        'title filterPeriod clear download'
        'filters filters filters filters'
        'groupBy groupBy groupBy groupBy'
    `,
    [theme.fn.smallerThan('md')]: {
      gridTemplateColumns: '1fr min-content min-content',
      gridTemplateAreas: `
        'title clear download'
        'filterPeriod filterPeriod filterPeriod'
        'filters filters filters'
        'groupBy groupBy groupBy'
        `,
    },
    [theme.fn.smallerThan('sm')]: {
      gridTemplateColumns: 'auto auto',
      gridTemplateAreas: `
        'title clear'
        'filterPeriod filterPeriod'
        'filters filters'
        'groupBy groupBy'
        `,
    },
  },
  title: {
    gridArea: 'title',
  },
  filterPeriod: {
    gridArea: 'filterPeriod',
  },
  clear: {
    gridArea: 'clear',
    [theme.fn.smallerThan('sm')]: {
      justifySelf: 'end',
    },
  },
  download: {
    gridArea: 'download',
    [theme.fn.smallerThan('sm')]: {
      display: 'none',
    },
  },
  filters: {
    gridArea: 'filters',
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gridTemplateAreas: `
    'filterClassType filterWeekday filterTimeRange filterCoach'
    'filterGroupByClass filterGroupByDay filterGroupByStartTime filterGroupByCoach'
    `,
    gap: theme.spacing.xs,
    [theme.fn.smallerThan('md')]: {
      gridTemplateColumns: 'repeat(2, 1fr)',
      gridTemplateAreas: `
        'filterClassType filterWeekday'
        'filterTimeRange filterCoach'
        'filterGroupByClass filterGroupByDay'
        'filterGroupByStartTime filterGroupByCoach'
      `,
      gap: theme.spacing.sm,
    },
    [theme.fn.smallerThan('sm')]: {
      gridTemplateColumns: 'repeat(2, 1fr)',
      gridTemplateAreas: `
        'filterClassType filterClassType'
        'filterWeekday filterWeekday'
        'filterTimeRange filterTimeRange'
        'filterCoach filterCoach'
        'filterGroupByClass filterGroupByDay'
        'filterGroupByStartTime filterGroupByCoach'
      `,
      gap: theme.spacing.sm,
    },
  },
  filterClassType: {
    gridArea: 'filterClassType',
  },
  filterWeekday: {
    gridArea: 'filterWeekday',
  },
  filterTimeRange: {
    gridArea: 'filterTimeRange',
  },
  filterCoach: {
    gridArea: 'filterCoach',
  },
  filterGroupByClass: {
    gridArea: 'filterGroupByClass',
  },
  filterGroupByDay: {
    gridArea: 'filterGroupByDay',
  },
  filterGroupByStartTime: {
    gridArea: 'filterGroupByStartTime',
  },
  filterGroupByCoach: {
    gridArea: 'filterGroupByCoach',
  },
}));

export default useStyles;
